import ReportPeriods from './ReportPeriods'

export default ReportPeriods
